import { Role } from '@ankor-io/common/types/account'

export const getUserRoleText = (role: Role): string => {
  switch (role) {
    case Role.OWNER:
      return 'Organization Owner'
    case Role.ADMIN:
      return 'Organization Admin'
    case Role.VESSEL_ADMIN:
      return 'Vessel Admin'
    case Role.APPROVER:
      return 'Approver'
    case Role.SPENDER:
      return 'Spender'
    case Role.VIEWER:
      return 'Viewer'
  }
}
